module.exports = __webpack_public_path__ + "assets/img/hill-3.d8631e6f.png";